import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const clients = [
  {
    name: "Satkar Hero",
    logo: "/images/clients/SATKAR-HERO-PNG.png",
    alt: "Satkar Hero Chhindwara"
  },
  {
    name: "Nahar Hospital",
    logo: "/images/clients/NAHAHR-LOGO-PNG.png",
    alt: "Nahar Hospital Chhindwara"
  },
  {
    name: "Nayyer Furniture",
    logo: "/images/clients/NAYYER-FURNITURE-PNG.png",
    alt: "Nayyer Furniture Chhindwara"
  },
  {
    name: "IPS International School",
    logo: "/images/clients/ips-international-school-png.png",
    alt: "IPS International School Chhindwara"
  },
  {
    name: "Garba Sweets",
    logo: "/images/clients/GARBASWEETS-PNG.png",
    alt: "Garba Sweets Chhindwara"
  },
  {
    name: "BSPS",
    logo: "/images/clients/bsps-logo-png-p.png",
    alt: "BSPS Chhindwara"
  }
];

export default function ClientLogos() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold mb-4">Our Happy Clients</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We've had the pleasure of working with these amazing businesses in Chhindwara and beyond.
          </p>
        </div>
        
        <div className="py-4">
          <Slider {...settings}>
            {clients.map((client, index) => (
              <div key={index} className="px-4">
                <div className="h-24 flex items-center justify-center">
                  <img 
                    src={client.logo} 
                    alt={client.alt} 
                    className="max-h-full max-w-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    title={client.name}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
